module.exports = __webpack_public_path__ + "img/electronic_pending_zone.4ba9d5d0.svg";